module.exports = __webpack_public_path__ + "img/page-22.71e16129.jpg";